module.exports = __webpack_public_path__ + "img/Decoration_de_table.92f1053.png";